import gql from 'graphql-tag'

export default gql`
  fragment MoneyContent on IWithMoney {
    currencyCode
    value
    format
    plain: format(mode: NUMBER_PLAIN)
  }
`
